import Application from './application/Application'
import run from './utils/run'
import '@fortawesome/fontawesome-free/js/all.js';

$(function() {
    run.init(Application);
});